import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'relativeDate' })
export class RelativeDatePipe implements PipeTransform {
    transform(inputDate: number): string {
        // Calculate date starting point, today and tomorrow
        let now = new Date();
        let dateDays = new Date(new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime());
        let today = dateDays.getTime();
        let tomorrow = new Date(dateDays).setHours(dateDays.getHours() + 24);

        // Extract date information from inpute date number
        let date = new Date(inputDate);
        let dateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

        const datePipe = new DatePipe('en-EN');

        if(dateTime == today) {
            return $localize`today`;
        }
        else if(dateTime == tomorrow) {
            return $localize`tomorrow`;
        }
        else {
            return datePipe.transform(date, 'EEEE, MMM dd');
        }
    }
}


@Component({
    selector: 'date-select',
    templateUrl: './date-select.component.html',
    styleUrls: ['./date-select.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DateSelectComponent implements OnInit {

    @Input('date') set date(date: Date) { this.initTime(date) };
    // Get selected date object chnage events
    @Output() dateChanged = new EventEmitter<Date>();
    // Convinience output to get data as a string ie.: today, tomorrow or Monday, June 2
    @Output() relativeDateStr = new EventEmitter<string>();

    public time: Date = null;
    public datePick: Date = null;
    public start: number = 0;
    public today: number = 0;
    public tomorrow: number = 0;
    private relativeDatePipe = new RelativeDatePipe();

    constructor() {
        this.initTime(new Date());
    }

    ngOnInit() {
    }

    private initTime(date: Date) {
        this.time = date;
        this.datePick = new Date(new Date(this.time.getFullYear(), this.time.getMonth(), this.time.getDate()).getTime());
        this.start = this.datePick.getTime();
        this.today = this.datePick.getTime();
        this.tomorrow = new Date(this.datePick).setHours(this.datePick.getHours() + 24);
        this.emitDateTime(this.datePick);
    }

    public pickNextDay() {
        // Set current date +24 hours and synch with time obj
        this.datePick = new Date(this.datePick.setHours(this.datePick.getHours() + 24));
        // Get timestamp without time info (at 00:00) for view
        this.start = this.datePick.getTime();
        this.emitDateTime(this.datePick);
    }

    public pickPrevDay() {
        // Set current date -24 hours and synch with time obj
        this.datePick = new Date(this.datePick.setHours(this.datePick.getHours() - 24));
        // Get timestamp without time info (at 00:00) for view
        this.start = this.datePick.getTime();
        this.emitDateTime(this.datePick);
    }

    public dateSelected(ev: Date) {
        this.start = ev.getTime();
        this.emitDateTime(ev);
    }

    private emitDateTime(date: Date) {
        // Synch time object
        this.time.setDate(date.getDate());
        this.time.setMonth(date.getMonth());
        this.time.setFullYear(date.getFullYear());
        // Emit change event
        this.dateChanged.emit(this.time);
        this.emitDateStr();
    }

    private emitDateStr() {
        let relativeStr = this.relativeDatePipe.transform(this.start);
        this.relativeDateStr.emit(relativeStr);
    }

    public timeSelected(ev: any) {
        let [hour, min] = ev.target.value.split(":");
        this.time = new Date(this.datePick.getTime());
        this.time.setHours(parseInt(hour));
        this.time.setMinutes(parseInt(min));
        // Never sync date object
        //this.start = this.startTime.getTime();
        this.dateChanged.emit(this.time);
        this.emitDateStr();
    }

    public resetTime() {
        this.initTime(new Date());
        this.dateChanged.emit(this.time);
        this.emitDateStr();
    }
}
